import { apiService } from "src/services";
import {
	IEditMetadataDiff,
	IEditMetadataView,
	IMetadataLastEdited,
} from "src/pages/EditMetadata/models/interfaces";
import { IResponse } from "src/pages/Studies/models/interfaces";

export const fetchEditMetadata = async (studyId: string): Promise<IEditMetadataView> => {
	const response: { data: IEditMetadataView } = await apiService.get(`files/metadata/${studyId}`, {});
	return response.data;
};

export const fetchMetadataLockStatus = async (studyId: string) => {
	return await apiService.get(`files/metadata/${studyId}/lock`, {});
};

export const acquireMetadataLock = async (studyId: string) => {
	return await apiService.post(`files/metadata/${studyId}/lock/acquire`, {});
};

export const heartbeatMetadataLock = async (studyId: string) => {
	return await apiService.post(`files/metadata/${studyId}/lock/heartbeat`, {});
};

export const releaseMetadataLock = async (studyId: string) => {
	return await apiService.post(`files/metadata/${studyId}/lock/release`, {});
};

export interface ISaveEditMetadataResponse {
	updated_files: number;
	touched_categories: string[];
	released_lock: boolean;
	metadata_last_edited: IMetadataLastEdited | null;
	data_version?: string | null;
}

export const saveEditMetadataBulk = async (
	studyId: string,
	diff: IEditMetadataDiff,
	releaseLockOnSuccess: boolean = true,
): Promise<IResponse<ISaveEditMetadataResponse>> => {
	const response: IResponse<ISaveEditMetadataResponse> = await apiService.post(
		`files/metadata/${studyId}/edit-bulk`,
		{ ...diff, release_lock_on_success: releaseLockOnSuccess },
	);
	return response;
};
